import { EntryBaseEntry } from './entry-base.entry';

export interface EstadoContadorEstablecimientoEntry extends EntryBaseEntry {
	estado_rnt_id: EstadoRnt;
	descripcion: string;
	cantidad: 0;
}

export enum EstadoRnt {
	A = 'A',
	S = 'S',
	C = 'C',
	D = 'D'
}
